import React, { useRef } from "react"

const FindsCarousel = ({ items }) => {
  const trackRef = useRef(null)

  const scrollByCard = direction => {
    if (!trackRef.current) {
      return
    }

    const card = trackRef.current.querySelector(".finds-card")
    const gap = 20
    const scrollAmount = card ? card.clientWidth + gap : 320

    trackRef.current.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    })
  }

  return (
    <section className="finds-section fade-content" aria-label="Good Finds carousel">
      <div className="finds-toolbar">
        <div>
          <div className="finds-label">CURATED NOW</div>
          <p className="finds-note">
            Click a card to open the item. Update the list in the page file any
            time you want to add more finds.
          </p>
        </div>

        <div className="finds-controls">
          <button
            type="button"
            className="finds-control"
            onClick={() => scrollByCard(-1)}
            aria-label="Scroll left"
          >
            Prev
          </button>
          <button
            type="button"
            className="finds-control"
            onClick={() => scrollByCard(1)}
            aria-label="Scroll right"
          >
            Next
          </button>
        </div>
      </div>

      <div className="finds-track" ref={trackRef}>
        {items.map(item => (
          <a
            key={item.name}
            className="finds-card"
            href={item.link}
            target="_blank"
            rel="noreferrer"
          >
            <div className="finds-card-image-wrap">
              <img
                className="finds-card-image"
                src={item.image}
                alt={item.name}
                loading="lazy"
              />
            </div>
            <div className="finds-card-body">
              <div className="finds-card-name">{item.name}</div>
              {item.note ? <p className="finds-card-note">{item.note}</p> : null}
              <div className="finds-card-footer">
                <div className="finds-card-link">open item</div>
                {item.imgUrl ? (
                  <a
                    className="finds-card-img-link"
                    href={item.imgUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={e => e.stopPropagation()}
                  >
                    IMG
                  </a>
                ) : null}
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  )
}

export default FindsCarousel
